<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/payment-received/${inputs.id}`
						: `transaction/payment-received`
				"
			>
				<!-- Invoice -->
				<div class="form-group row align-items-center">
					<label for="inputs_invoice_fk" class="col-sm-3 mb-0">
						Invoice
					</label>
					<app-input
						id="inputs_invoice_fk"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_invoice_fk"
						@input="setInvoiceFkValue"
						fetch-url="transaction/invoice"
						placeholder="Invoice"
						list-value-field="invoice_no"
						:required="true"
					/>
				</div>

				<!-- Bank Account -->
				<div class="form-group row align-items-center">
					<label for="inputs_bank_account_id" class="col-sm-3 mb-0">
						Bank Account
					</label>
					<app-input
						id="inputs_bank_account_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_bank_account_id"
						@input="setBankAccountIdValue"
						fetch-url="master/bank-account?is_active=true"
						placeholder="Bank Account"
						list-value-field="bank_account_virtual_no"
						:required="true"
					/>
				</div>

				<!-- Received Value -->
				<div class="form-group row align-items-center">
					<label for="inputs_received_value" class="col-sm-3 mb-0">
						Received Value
					</label>
					<app-input
						id="inputs_received_value"
						class="col-sm-9"
						type="number"
						v-model="inputs.received_value"
						:placeholder="'Received Value'"
						:required="true"
					/>
				</div>

				<!-- Received Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_received_date" class="col-sm-3 mb-0">
						Received Date
					</label>
					<app-input
						id="inputs_received_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.received_date"
						:placeholder="'Received Date'"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					id: "",
					name: "",
				};
			},
		},
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			input_invoice_fk: this.value
				? this.value.data
					? {
							id: this.value.data.id || 0,
							invoice_no: this.value.data.invoice_no || "",
							request_no: this.value.data.request_no || "",
					  }
					: {
							id: this.value.data?.id || 0,
							invoice_no: this.value.data?.invoice_no || "",
							request_no: this.value.data?.request_no || "",
					  }
				: {
						id: this.value.data.id || 0,
						invoice_no: this.value.data.invoice_no || "",
						request_no: this.value.data.request_no || "",
				  },
			input_bank_account_id: this.value
				? this.value.data
					? {
							id: this.value.data.id || 0,
							bank_account_virtual_no:
								this.value.data.bank_account_virtual_no || "",
					  }
					: {
							id: this.value.data?.id || 0,
							bank_account_virtual_no:
								this.value.data?.bank_account_virtual_no || "",
					  }
				: {
						id: this.value.data.id || 0,
						bank_account_virtual_no:
							this.value.data.bank_account_virtual_no || "",
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.inputs.received_date = this.inputs.received_date
				? this.formattedDate(this.inputs.received_date)
				: this.formattedDate(new Date());
			this.inputs.source_id = 0;
			if (this.selectedUrl) {
				this.inputs.invoice_fk = this.inputs.invoice_fk?.id || 0;
				this.inputs.bank_account_id =
					this.inputs.bank_account_id?.id || 0;
			}
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.input_invoice_fk = {
				id: response.data.invoice_fk?.id || 0,
				invoice_no: response.data.invoice_fk?.invoice_no || "",
				request_no: response.data.invoice_fk?.request_no || "",
			};
			this.input_bank_account_id = {
				id: response.data.bank_account_id?.id || 0,
				bank_account_virtual_no:
					response.data.bank_account_id?.bank_account_virtual_no ||
					"",
			};
			this.preloader = false;
		},
		setInvoiceFkValue(data) {
			this.inputs.invoice_fk = this.inputs.invoice_fk;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.invoice_fk = data.id;
			}
		},
		setBankAccountIdValue(data) {
			this.inputs.bank_account_id = this.inputs.bank_account_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.bank_account_id = data.id;
			}
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
